import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import API from '../../utils/api/API';
import Button from '../../elements/Button';
import Popup from '../Popup';
import { useClosePopup } from '../../utils/hooks/usePopup';
import Objects from '../../utils/api/Objects';
import Images from '../../utils/api/Images';
import Auctions from '../../utils/api/Auctions';
import ImageSelector from '../../elements/ImageSelector';
import { Context } from '../../App';

export default function CreateObject({}) {
	let history = useHistory();
	const close = useClosePopup();

	const [image, setImage] = useState();


	const submit = async (e) => {
		e.preventDefault();
		let form = e.target;

		let title = form.querySelector('input[name="object_name"]').value;
		let description = form.querySelector('textarea[name="object_description"]').value;

		let data = {
			title,
			description,
		};

		// If theres an image uploaded, insert it to the body.
		if (image) data.thumbnail = image.id;

		console.log(data);

		let result = await Objects.create(data);

		if (result) {
			let cache = API.getCached(`_/objects_`);

			cache.result = [...cache.result, result];

			API.updateCache(`_/objects_`, cache);

			close();
		}
	};

	return (
		<Popup close={close} width="40em" maxWidth="80em">
			<Style onSubmit={submit}>
				<h2 className="title">Skapa objekt</h2>
				<div className="spacer m"></div>

				<div className="fields">
					<label>Bild</label>
					<br />
					<ImageSelector
						onChange={(image) => {
							setImage(image);
						}}
					/>

					<div className="spacer s"></div>

					<label htmlFor="object_name">Namn</label>
					<br />
					<input required type="text" name="object_name" />

					<div className="spacer s"></div>

					<label htmlFor="object_description">Beskrivning</label>
					<br />
					<textarea rows={10} name="object_description"></textarea>
				</div>

				<div className="spacer s"></div>

				<div className="buttons">
					<Button type={'secondary'} onClick={close}>
						Avbryt
					</Button>
					<input className="button" type="submit" value="Spara" />
				</div>
			</Style>
		</Popup>
	);
}

const Style = styled.form`
	.fields {
		width: 100%;

		input,
		textarea {
			width: 100%;
			resize: none;
		}
	}
`;
